import { SearchMatchType } from '@aibees/elephant/types';
import { capitalize } from '@aibees/shared/utils';
import {
  ClassificationGroups,
  ClassificationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function industryFilterConfig(): SearchFilterBase {
  return {
    id: 'Industry',
    name: 'Industry',
    icon: 'factory',
    index: 15,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    layer: 3,
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Industry Search',
        },
      },
    },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'include_industry',
        key: 'include_industry',
        layer: 4,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          preset: 'industry',
          placeholder: 'Include Industry ( OR ) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.COMPANY}&key=${ClassificationType.INDUSTRY}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 1,
        layer: 4,
        key: 'exclude_industry',
        field: 'exclude_industry',
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'industry',
          placeholder: 'Exclude Industry ( OR ) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.COMPANY}&key=${ClassificationType.INDUSTRY}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
    ],
  };
}
